import React from "react";

interface BadgeProps {
  children: React.ReactNode;
  type?: "primary" | "secondary" | "danger" | "success" | "warning" | "info";
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({
  children,
  type = "primary",
  className,
}) => {
  const colorMap = {
    primary:
      "text-[var(--app-primary)] bg-[var(--icon-bg-primary)] text-[var(--app-primary)] border border-[var(--app-primary)]",
    secondary:
      "text-[var(--app-secondary)] bg-[var(--icon-bg-secondary)] text-[var(--app-secondary)] border border-[var(--app-secondary)]",
    info: "text-gray-500 bg-gray-100 text-gray-600 border border-gray-200",
    danger: "text-red-500 bg-red-100 text-red-700 border border-red-200",
    warning:
      "text-yellow-500 bg-yellow-100 text-yellow-700 border border-yellow-200",
    success:
      "text-green-500 bg-green-100 text-green-700 border border-green-200",
  };
  return (
    <div
      className={`text-xs ${colorMap[type]} px-2.5 py-0.5 rounded-full ${className}`}
    >
      {children}
    </div>
  );
};

export default Badge;
